import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from 'axios';
import Paginator from "../../components/Paginator";
import InnerNav from "../../components/InnerNav";
import Wrapper from "../../components/Wrapper";
import { AiFillEdit, AiFillDelete } from "react-icons/ai";
const MarketingPayouts = ()=>{
    const [marketingPayouts, setMarketingPayouts] = useState([]);
    const [page, setPage] = useState(1);
    const [lastPage, setLastPage] = useState(1);
    useEffect(() => {
        (
        async () => {

            const {data} = await axios.get(`marketingPayout?page=${page}`);
            setMarketingPayouts(data.data);
            setLastPage(data.meta.last_page)

        }
        )();
    },[page]);
    const del = async (id) =>{
        if(window.confirm("Are you sure you want to delete this record?")){
            await axios.delete(`marketingPayout/${id}`);
            setMarketingPayouts(marketingPayouts.filter((marketingPayout) => marketingPayout.id !== id));
        }
    }
    return (
        <Wrapper pageTitle={'MarketingPayouts'}>
            <InnerNav createLink={'/marketingPayoutCreate'} listLink={'/marketingPayouts'} />
                <div className="w-full overflow-hidden rounded-lg shadow-xs">
                    <div className="w-full overflow-x-auto">
                        <table className="w-full whitespace-no-wrap">
                            <thead>
                                <tr className="text-xs font-semibold tracking-wide text-left text-gray-500 uppercase border-b dark:border-gray-700 bg-gray-50 dark:text-gray-400 dark:bg-gray-800" >
                                    <th className="px-4 py-3">#Ref </th>
                                    <th className="px-4 py-3">Msisdn </th>
                                    <th className="px-4 py-3">Amount </th>
                                    <th className="px-4 py-3">Date </th>
                                    <th className="px-4 py-3">PayDesc </th>
                                    <th className="px-4 py-3">TimeFrom </th>
                                    <th className="px-4 py-3">TimeTo </th>
                                    <th className="px-4 py-3">Approved </th> 
                                     <th className="px-4 py-3">Action</th>
                                </tr>
                                </thead>
                                <tbody className="bg-white divide-y dark:divide-gray-700 dark:bg-gray-800" >
                                    {marketingPayouts.map((marketingPayout)=>{
                                         return(
                                             <tr key={marketingPayout.id} className="text-gray-700 dark:text-gray-400">
                                                 <td className="px-4 py-5">{marketingPayout.id}</td>
                                                 <td className="px-4 py-3 text-sm">{marketingPayout.msisdn}</td>
                                                 <td className="px-4 py-3 text-sm">{marketingPayout.amount}</td>
                                                 <td className="px-4 py-3 text-sm">{marketingPayout.date}</td>
                                                 <td className="px-4 py-3 text-sm">{marketingPayout.pay_desc}</td>
                                                 <td className="px-4 py-3 text-sm">{marketingPayout.time_to}</td>
                                                 <td className="px-4 py-3 text-sm">{marketingPayout.time_from}</td>
                                                 <td className="px-4 py-3 text-sm">{marketingPayout.approved}</td>
                                                 <td className="flex px-4 py-3 text-sm"><Link className="btn btn-sm btn-outline-secondary px-5" to={`/marketingPayout/${marketingPayout.id}/edit`}><AiFillEdit/> </Link><span className="btn btn-sm btn-outline-secondary" onClick={()=>del(marketingPayout.id)}> <AiFillDelete className="text-rose-500 text-lg"/></span></td>
                                             </tr>
                                         );
                                     })
                                 }
                            </tbody>
                        </table>
                    </div>
                    <Paginator lastPage={lastPage} pageChanged={setPage} />
                </div>
             </Wrapper>
         );
};
export default MarketingPayouts;